import { Button, ChevronDownSVG, ChevronUpSVG } from "@newsela/angelou";

import {
  withTrackEvent,
  objectTypes,
  actionNames,
  actionPrefixes,
} from "@newsela/snitch";
import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";
import { LangstonParameterSchema } from "../../LangstonParameterSchema";
import { VisibilityPermissions } from "../VisibilityPermissions";
import {
  buttonCss,
  filterAndSortVisibilityCss,
  filterHeaderContainerCss,
  needleCss,
  totalResultsCss,
} from "./FilterHeader.styles";

const ButtonWithTrackEvent = withTrackEvent(Button);

const eventProperties = {
  objectType: objectTypes.content,
  actionPrefix: actionPrefixes.initiate,
  actionName: actionNames.filter,
  streamProperties: {
    description: "Open or close the search filter panel on smaller screens",
  },
};

export const FilterHeader = ({
  isFilterPanelOpen,
  setIsFilterPanelOpen,
}: IFilterHeader) => {
  const {
    getters: { isDisabledFilters, searchResponse, isSearchLoading },
    handlers: { getSearchParamValues },
  } = useSearchPageContext();

  const needleValue = getSearchParamValues(
    LangstonParameterSchema.needle.key,
  )?.[0];
  const totalResultCount = isDisabledFilters
    ? "68" // Set results to 68 when worksheets are enabled.
    : searchResponse?.total_result_count || 0;

  return (
    <div css={filterHeaderContainerCss}>
      <div css={totalResultsCss}>
        <span>
          {isSearchLoading
            ? "Loading results..."
            : `${Intl.NumberFormat("en-US").format(totalResultCount)} most relevant results`}
          {needleValue && (
            <span>
              &nbsp;for <span css={needleCss}>{`"${needleValue}"`}</span>
            </span>
          )}
        </span>
        <span>{isSearchLoading && "..."}</span>
        <div css={filterAndSortVisibilityCss}>
          <ButtonWithTrackEvent
            __cssFor={buttonCss}
            flavor={Button.flavors.primary}
            onClick={() => setIsFilterPanelOpen(!isFilterPanelOpen)}
            icon={{
              SvgComponent: isFilterPanelOpen ? ChevronUpSVG : ChevronDownSVG,
              alignment: Button.iconAlignments.right,
            }}
            dataProps={{
              "data-testid": isFilterPanelOpen
                ? "chevron-up-icon"
                : "chevron-down-icon",
            }}
            {...eventProperties}
          >
            Filter and sort
          </ButtonWithTrackEvent>
        </div>
      </div>

      <VisibilityPermissions />
    </div>
  );
};

interface IFilterHeader {
  isFilterPanelOpen: boolean;
  setIsFilterPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
